import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TToggleSaveCardStatus = IAction<EPaymentActions.TOGGLE_SAVE_CARD_STATUS, boolean>

const toggleSaveCardStatus = (status: boolean): TToggleSaveCardStatus => ({
    type: EPaymentActions.TOGGLE_SAVE_CARD_STATUS,
    payload: status,
});

export default toggleSaveCardStatus;
